import { Label } from '@/components/ui/label';
import { Loader2, Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function EmptyInputFile({
  contentType,
  type,
  isLoading,
}: {
  contentType: string;
  type?: string;
  isLoading?: boolean;
}) {
  const { t } = useTranslation('createWebinar');

  const getUploadingText = () => {
    if (type === 'pdf') {
      return t('pdfsForm.uploading');
    } else if (type === 'video') {
      return t('videosForm.uploading');
    }
    return t('pdfsForm.uploading');
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="w-full rounded-lg p-4 bg-decorative-2 cursor-pointer flex items-center justify-center flex-col gap-2">
        {isLoading ? (
          <>
            <Loader2 className="size-6 animate-spin text-primary" />
            <Label className="cursor-pointer">{getUploadingText()}</Label>
          </>
        ) : (
          <>
            <Plus className="size-6 text-primary" />
            <Label className="">
              {t('add')} {contentType}
            </Label>
          </>
        )}
      </div>
    </div>
  );
}
